import 'css-chunksrc/client/scenes/workloads/wbs/task/dateForm/styles.scss';export default {
  "dateForm": "_dateForm_ds7s0_1",
  "input": "_input_ds7s0_5",
  "readOnly": "_readOnly_ds7s0_12",
  "disabled": "_disabled_ds7s0_18"
};